/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const QuantPage = lazyLoad(
  () => import('./index'),
  module => module.QuantPage,
);
